import type { FormControlSetting } from '@/app/editor/iframe/atom/Atom.model';

import { GpThirdParty } from '@/app/editor/iframe/atom/third-party/GpThirdParty';
const FormControlSettings: Array<FormControlSetting> = [
  {
    type: 'html:attr',
    name: 'compile',
    property: 'data-compile',
    targetSelector: 'self',
    visible: 'field-hide-all',
    default_value: 'false',
  },
  {
    type: 'html:attr',
    refreshType: 'all',
    property: 'data-widget',
    targetSelector: '.module',
    name: 'widget',
    options: [
      {
        key: 'evm-related-product',
        value: 'Related Products',
      },
      {
        key: 'evm-also-bought-products',
        value: 'Frequently Bought Together',
      },
      {
        key: 'evm-featured-collections-product',
        value: 'Featured Products',
      },
      {
        key: 'evm-recommended-products',
        value: 'Manual Recommendations',
      },
      {
        key: 'evm-most-popular-products',
        value: 'Top Selling Recommendations',
      },
      {
        key: 'evm-new-arrivals-product',
        value: 'New Arrivals',
      },
      {
        key: 'recently-viewed',
        value: 'Recently Viewed Products',
      },
      {
        key: 'evm-recent_purchased_recomm-product',
        value: 'Recommendations Based On Past Purchases',
      },
      {
        key: 'evm-recent_purchased-product',
        value: 'Products Purchased Before',
      },
      {
        key: 'trending-products',
        value: 'Trending Products',
      },
      {
        key: 'evm-related-viewed-browsing',
        value: 'AI Based Recommendations',
      },
    ],
    default_value: 'recentview',
  },
  {
    type: 'custom:align',
    name: 'alignment',
    targetSelector: '.module',
    property: '',
  },
  {
    type: 'html:extraClass',
    name: 'extra_class',
    targetSelector: '.module',
    property: 'data-exc',
    default_value: '',
  },
];
/**
 * GpWiserPersonalizedRecommendations Atom
 */
export class GpWiserPersonalizedRecommendations extends GpThirdParty {
  public $el: JQuery;

  /**
   * override getLabel từ Atom
   * @returns Name
   */
  getLabel(): string {
    return this.$el.attr('data-label') || 'Wiser - Personalized Recommendations';
  }
  /**
   * override getSlug từ Atom
   * @returns Slug
   */
  getSlug(): string {
    return this.$el.attr('data-slug') || 'wiser-personalized-recommendations-v2';
  }
  /**
   * getFormControlSettings;
   * @returns setting read/write from left-sidebar to live page
   */
  getFormControlSettings(): Array<FormControlSetting> {
    return FormControlSettings;
  }

  /**
   * check
   * @returns true: change setting after drag
   */
  isAutoRenderSetting() {
    return true;
  }
}
